// Central content store for Srishti Agarwal's portfolio.
// Add new case studies here (e.g. after uploading new PDFs).

export const PROFILE = {
  name: "Srishti Agarwal",
  role: "Brand & Creative Strategist",
  location: "Bengaluru, India",
  email: "srishagarwal96@gmail.com",
  phone: "+91 99098 11000",
  linkedin: "https://linkedin.com/in/srishtia96",
  linkedinLabel: "Srishti Agarwal",
  substack: "https://substack.com/@agarwalsrishti",
  substackLabel: "substack.com/@agarwalsrishti",
  resumeUrl:
    "https://customer-assets-wrfwihn1.emergentagent.net/job_strategy-portfolio-16/artifacts/exvtua9e_Srishti%20Resume%202026.pdf",
  years: "7+",
};

export const HERO_LINES = [
  "I know how to put",
  "it into words.",
];

export const MANIFESTO = [
  {
    no: "01",
    title: "Words first, always.",
    body:
      "I started in advertising as a copywriter, chasing the line that makes you stop and think, ‘damn, why didn’t I say that?’. That instinct never left. Every brand I touch begins with a sentence sharp enough to build a business on.",
  },
  {
    no: "02",
    title: "Strategy is empathy with a spine.",
    body:
      "Seven years across agencies, startups and my own brand taught me that positioning is really just knowing a person better than they know themselves, then having the nerve to say it out loud.",
  },
  {
    no: "03",
    title: "From concept to finished, fast.",
    body:
      "I use AI to move from a big idea to real, made things in days, not months. Brand books, launches, campaigns, insight in, work out.",
  },
];

export const MARQUEE_WORDS = [
  "Ownly",
  "PartySmart",
  "LocoBear",
  "Federal Bank",
  "Godrej",
  "Gujarat Titans",
  "UNCOLOGNE",
  "Astral",
  "Billabong",
  "FamPay",
];

// Brand-mark tiles used as case-study thumbnails (a cohesive client logo wall).
// LocoBear uses the real logo extracted from the brand manual.
export const MARKS = {
  ownly: { img: "/logos/ownly.jpg" },
  partysmart: { img: "/logos/partysmart.jpg" },
  locobear: { img: "/locobear-logo.jpg" },
  saarthi: { img: "/logos/saarthi.jpg" },
  uncologne: {
    lockup: true,
    bg: "#14110F",
    fg: "#E7DECB",
    wordmark: "UNCOLOGNE",
    over: "Fine Fragrance",
    tagline: "Before we were standardised",
  },
  billabong: { img: "/logos/billabong.jpg" },
  bpl: { img: "/logos/bpl.jpg" },
  fampay: { img: "/logos/fampay.jpg" },
  godrej: { img: "/logos/godrej-realgood.jpg" },
  "love-water": { bg: "#0E7CC4", fg: "#FFFFFF", wordmark: "Love Water", weight: 700 },
  yourdost: { img: "/logos/yourdost.jpg" },
};

export const getMark = (slug) => MARKS[slug] || { bg: "#0A0A0A", fg: "#F4F3EF", wordmark: slug };


const WORK_SOURCE = [
  {
    slug: "ownly",
    title: "Ownly",
    client: "Rapido",
    year: "2025",
    discipline: "Brand Strategy & Positioning",
    tagline: "Own Your Moment.",
    summary:
      "Go-to-market positioning and brand architecture for Rapido’s entry into online food delivery.",
    cover:
      "https://images.unsplash.com/photo-1546069901-ba9599a7e63c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    size: "large",
    brief:
      "Build a food-delivery brand for young, busy people who want control and convenience, a brand that goes beyond ‘we bring food’ to a genuine sense of ownership over your own moments.",
    insight:
      "People don’t just want food delivered. They want a small, earned pocket of the day that belongs entirely to them, no self-sacrifice, no negotiation.",
    idea:
      "Ownly means Own Your Moment. A positioning built on empowerment in the NOW: freedom, autonomy, and a simple answer that asks nothing of you in return.",
    approach: [
      "Named the brand ‘Ownly’ to carry ownership and individuality in a single word.",
      "Kept the architecture ruthlessly simple, clarity over cleverness, needs answered without noise.",
      "Set a confident, wry, no-nonsense tone, the sharp, grounded friend who gets that your day is a mess and winks at it.",
    ],
    lines: [
      "Because your hustle deserves something hotter than your laptop.",
      "Here’s your peace of cake.",
      "Your brain’s on 17 tabs. Let us be the one that delivers.",
      "Welcome to a simple hack for hard days.",
    ],
    gallery: [
      "/ownly/ownly-01.jpg", "/ownly/ownly-02.jpg", "/ownly/ownly-03.jpg",
      "/ownly/ownly-04.jpg", "/ownly/ownly-05.jpg", "/ownly/ownly-06.jpg",
      "/ownly/ownly-07.jpg", "/ownly/ownly-08.jpg", "/ownly/ownly-09.jpg",
    ],
    galleryNote: "the actual work: personas, positioning and tone of voice. messy, real, figured out as we went.",
    result: "Positioning, naming rationale and brand architecture delivered end-to-end.",
  },
  {
    slug: "partysmart",
    title: "PartySmart",
    client: "Party Smart India",
    year: "2025",
    discipline: "Brand Book & Positioning",
    tagline: "Outsmart Hangovers.",
    summary: "A ground-up brand book that moved PartySmart from ‘medicine’ to lifestyle.",
    cover:
      "https://images.unsplash.com/photo-1514362545857-3bc16c4c7d1b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    size: "small",
    brief:
      "Reposition PartySmart away from a medicinal, morning-after remedy into an essential, lifestyle-driven social companion, and write the brand book from scratch.",
    insight:
      "The modern socialiser refuses the trade-off between a great night and a functional tomorrow. Wellness isn’t a rulebook to them; it’s a smart flex.",
    idea:
      "The wellness-forward social companion, empowering fun-loving people to make the smarter choice and still be fully in every moment.",
    approach: [
      "Wrote the full brand book: positioning, personality and voice from a blank page.",
      "Set a tone that is fun, quirky, confident and relatable, never preachy, clinical or salesy.",
      "Framed a unified brand able to stretch across a growing product range, from capsules to gummies.",
    ],
    lines: [],
    gallery: [
      "/partysmart/ps-01.jpg", "/partysmart/ps-02.jpg", "/partysmart/ps-03.jpg", "/partysmart/ps-04.jpg",
      "/partysmart/ps-05.jpg", "/partysmart/ps-06.jpg", "/partysmart/ps-07.jpg", "/partysmart/ps-08.jpg",
    ],
    result: "Complete brand book delivered, defining voice, personality and range architecture.",
  },
  {
    slug: "locobear",
    title: "LocoBear",
    client: "LocoBear",
    year: "2023-24",
    discipline: "Head of Marketing · Brand Launch",
    tagline: "A city launch, sold on story.",
    summary: "Led LocoBear’s Bengaluru launch, 80% of first-month footfall traced to social.",
    cover: "/locobear-logo.jpg",
    fullColor: true,
    size: "large",
    brief:
      "Launch LocoBear in Bengaluru and build brand visibility fast across new cities with a lean team.",
    insight:
      "A new-city launch lives or dies on word-of-mouth engineered at speed, the right voices, the right rooms, before the doors even open.",
    idea:
      "Turn the launch itself into content, flood the feed with reasons to show up, then measure everything back to footfall.",
    approach: [
      "Ran 90+ influencer collaborations in 50 days.",
      "Built and led a team of 5 across Raipur, Surat and Bengaluru.",
      "Identified, negotiated and managed marketing & PR agencies across 3 cities.",
    ],
    lines: [
      "80% of first-month footfall, traced directly to social.",
      "Instagram engagement rate: 83.6%.",
      "3,500+ footfall driven to the Loco Lounge.",
    ],
    links: [
      { url: "https://www.instagram.com/reel/CyDwMqfoDGC/?igsh=MTMwbm5qdGh5dWJuaw==", label: "here’s how the launch happened" },
      { url: "https://www.instagram.com/locobear.india/", label: "locobear on instagram" },
    ],
    gallery: [
      "/locobear/loco-01.jpg", "/locobear/loco-02.jpg", "/locobear/loco-03.jpg", "/locobear/loco-04.jpg",
    ],
    result: "80% of first-month footfall attributed to social; 3,500+ walk-ins to the Loco Lounge.",
  },
  {
    slug: "saarthi",
    title: "Saarthi.ai",
    client: "Saarthi.ai",
    year: "2023",
    discipline: "Head of Content & Outreach",
    tagline: "From podcast to page, all me.",
    summary:
      "Launched Manthan, the founder’s dream podcast, and owned every word across web and social.",
    cover: "/logos/saarthi.jpg",
    size: "large",
    link: { url: "https://www.youtube.com/@ManthanBySaarthi", label: "Watch Manthan on YouTube" },
    brief:
      "Build Saarthi.ai’s voice from scratch, and give the founder’s thinking a stage.",
    insight:
      "A deep-tech company earns trust through ideas, not ads.",
    idea:
      "Manthan: a podcast that turns the founder’s thinking into a movement.",
    approach: [
      "Conceived and launched Manthan, the company’s first podcast, on YouTube, Spotify and Amazon.",
      "Ran the internal podcast, The Deep Take, with founder Sangram.",
      "Owned LinkedIn and Instagram.",
    ],
    lines: [],
    result: "Launched Manthan; +30% engagement, +15% ICP following, 2,000+ organic site visitors.",
  },

  {
    slug: "uncologne",
    title: "UNCOLOGNE",
    year: "2026",
    discipline: "Founder · Brand Architecture",
    tagline: "Before we were standardised.",
    summary:
      "A fine fragrance house that reclaims what refinement smelled like in India before 1858.",
    cover: "/logos/uncologne-cover.jpg",
    size: "large",
    insight:
      "India never needed cologne. It already had structure: architecture, water, stone, ritual upkeep. Modern perfumery sells drama, seduction and excess. There is a quieter, older, truer language of scent waiting to be reclaimed.",
    lines: [],
    architecture: {
      collections: [
        {
          no: "01",
          name: "The House Before 1858",
          idea: "Composure at dawn.",
          note: "This smells prepared, not performed.",
          behaviour: "Readiness. Presence. Control.",
        },
        {
          no: "02",
          name: "Upkeep",
          idea: "The smell of maintenance.",
          note: "Aged Indian Vetiver (Khus), rice starch, banana leaf, sun-dried cotton.",
          behaviour: "Dry. Mineral. Clean without soap.",
        },
        {
          no: "03",
          name: "Reserve",
          idea: "Warm skin. Controlled heat.",
          note: "Pepper becomes discipline. Musk becomes breath.",
          behaviour: "Held back, never loud.",
        },
        {
          no: "04",
          name: "Inner Court",
          idea: "Pre-1858 homes were built inward. Private. Cooled. Protected.",
          note: "Limestone shade at 3pm.",
          behaviour: "Architectural. Airy. Interior.",
        },
        {
          no: "05",
          name: "Continuum",
          idea: "Lineage. Repetition. Continuity.",
          note: "This feels passed down.",
          behaviour: "Inherited. Textural. Intimate.",
        },
      ],
      prioritise: [
        "Mysore sandalwood",
        "Aged khus",
        "Kewra distillation",
        "Black pepper CO2",
        "Rose hydrosol",
        "Amyris",
      ],
      avoid: [
        "Synthetic sweetness",
        "Over-sugared florals",
        "Market-style spice",
        "Overused oud tropes",
      ],
      finalStatement: "India did not need cologne. It had structure. UNCOLOGNE restores that structure.",
    },
    galleryLabel: "Inspiration & Direction",
    galleryNote: "the world the house lives in.",
    gallery: [
      "/uncologne/mood-01.jpg",
      "/uncologne/mood-02.jpg",
      "/uncologne/mood-03.jpg",
      "/uncologne/mood-04.jpg",
      "/uncologne/mood-05.jpg",
      "/uncologne/mood-06.jpg",
      "/uncologne/mood-07.jpg",
      "/uncologne/mood-08.jpg",
      "/uncologne/mood-09.jpg",
      "/uncologne/mood-10.jpg",
    ],
    result: "A live house with a five-part architecture, a defined material discipline and a B2B gifting pipeline.",
  },
  {
    slug: "yourdost",
    title: "The A to Z of Your State of Mind",
    client: "YourDOST",
    year: "2024",
    discipline: "Content Strategy · Copywriting",
    tagline: "Mental health, alphabetised.",
    summary:
      "An A to Z mental health dictionary built as endlessly shareable social posts.",
    cover:
      "https://images.unsplash.com/photo-1499209974431-9dddcece7f88?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    size: "small",
    brief:
      "Create an Instagram carousel that earns real traction and engagement from followers of a mental-health platform.",
    insight:
      "People don’t want to be lectured about their feelings. They want to be seen, with a little humour and zero judgement.",
    idea:
      "An A to Z of your state of mind: relatable, funny, honest definitions that normalise the ups and downs and slide straight into a save-and-share.",
    approach: [
      "Wrote a full A-to-Z dictionary of mental-health moods and micro-tips.",
      "Designed each entry to stand alone as a shareable post across platforms.",
    ],
    lines: [],
    gallery: [
      "/yourdost/az-01.jpg", "/yourdost/az-02.jpg", "/yourdost/az-03.jpg", "/yourdost/az-04.jpg",
      "/yourdost/az-05.jpg", "/yourdost/az-06.jpg", "/yourdost/az-07.jpg", "/yourdost/az-08.jpg",
      "/yourdost/az-09.jpg", "/yourdost/az-10.jpg", "/yourdost/az-11.jpg", "/yourdost/az-12.jpg",
      "/yourdost/az-13.jpg", "/yourdost/az-14.jpg", "/yourdost/az-15.jpg", "/yourdost/az-16.jpg",
      "/yourdost/az-17.jpg", "/yourdost/az-18.jpg", "/yourdost/az-19.jpg", "/yourdost/az-20.jpg",
      "/yourdost/az-21.jpg", "/yourdost/az-22.jpg", "/yourdost/az-23.jpg", "/yourdost/az-24.jpg",
      "/yourdost/az-25.jpg", "/yourdost/az-26.jpg", "/yourdost/az-27.jpg",
    ],
    result: "A modular, save-worthy content series that made mental health easy to talk about.",
  },
  {
    slug: "billabong",
    title: "The School of Thought",
    client: "Billabong High School",
    year: "2021-22",
    discipline: "Campaign · Copywriting",
    tagline: "We are for every child who thinks.",
    summary: "A print campaign that lifted admission enquiries by over 25%.",
    cover:
      "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    size: "small",
    brief: "Get the phone ringing with admission enquiries.",
    insight:
      "Most schools quietly punish curiosity. Parents are looking for the one that rewards it.",
    idea:
      "‘The School of Thought’, not a school of Nos and Nots, but a place that nurtures thoughts of all shapes and sizes.",
    approach: [
      "Built the ‘School of Thought’ platform and scripted the print campaign.",
      "Anchored three pillars: Global Perspective, Neuroscience of learning, and Genius Hour.",
    ],
    lines: [],
    gallery: [
      "/billabong/bb-01.jpg", "/billabong/bb-02.jpg", "/billabong/bb-03.jpg", "/billabong/bb-04.jpg",
    ],
    result: ">25% increase in admission enquiries.",
  },
  {
    slug: "bpl",
    title: "#HappyLittleThings",
    client: "BPL",
    year: "2021-22",
    discipline: "Brand Revamp · Copywriting",
    tagline: "Joy, in the small print of life.",
    summary: "Revamped BPL’s tone and look, young, fresh, relatable.",
    cover:
      "https://images.unsplash.com/photo-1585386959984-a4155224a1ad?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    size: "small",
    brief: "Revamp the tonality, look and feel of a legacy brand.",
    insight:
      "Legacy appliance brands sell specs. People remember the small everyday reliefs those specs quietly deliver.",
    idea:
      "#HappyLittleThings, reframe every product benefit as a tiny, felt joy in daily life.",
    approach: [
      "Rebuilt the brand voice to feel young, fresh and relatable.",
      "Turned product features into billboard-ready ‘happy little things’.",
    ],
    lines: [],
    gallery: [
      "/bpl/bpl-01.jpg", "/bpl/bpl-02.jpg", "/bpl/bpl-03.jpg",
    ],
    result: "A refreshed, relatable brave voice for a legacy brand.",
  },
  {
    slug: "fampay",
    title: "FamPay",
    client: "FamPay",
    year: "Campaign",
    discipline: "Social Campaign · Copywriting",
    tagline: "No cap. Just cards.",
    summary: "Instagram stories & ads that sold FamCards to teens in their own language.",
    cover:
      "https://images.unsplash.com/photo-1611262588024-d12430b98920?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    size: "small",
    brief:
      "Launch merchandise via Instagram Stories and sell FamCards to teens through Instagram ads.",
    insight:
      "Teens don’t respond to being marketed to. They respond to being spoken to, in their slang, with the joke already in on itself.",
    idea:
      "Write ads that sound like a group chat, not a bank, attention-seeking apparel and cheeky FamCard prompts.",
    approach: [
      "Scripted a serialised Instagram Stories narrative for the merch launch.",
      "Wrote scroll-stopping FamCard ads built on teen humour and pop-culture nods.",
    ],
    lines: [],
    gallery: [
      "/fampay/fp-01.jpg", "/fampay/fp-02.jpg", "/fampay/fp-03.jpg", "/fampay/fp-04.jpg",
    ],
    result: "A full-funnel social series in a native teen voice.",
  },
  {
    slug: "godrej",
    title: "Godrej Foods",
    client: "The Womb Communications",
    year: "2021-22",
    discipline: "Social · Copywriting",
    tagline: "Frozen food, thawed personality.",
    summary: "Social for Real Good Chicken & Yummiez, grew followers by 2K in 3 months.",
    cover:
      "https://images.unsplash.com/photo-1606787366850-de6330128bfc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    size: "small",
    brief: "Own social media for Godrej’s frozen food category, Real Good Chicken and Yummiez.",
    insight:
      "Frozen food is a low-interest category. Personality is the only thing that earns a follow.",
    idea:
      "Give the products a voice, pun-forward, playful, unabashedly snackable content.",
    approach: [
      "Ran always-on social for two Godrej frozen-food brands.",
      "Built UGC-friendly, pun-led creative to drive engagement.",
    ],
    lines: [],
    gallery: [
      "/godrej/gd-01.jpg", "/godrej/gd-02.jpg", "/godrej/gd-03.jpg",
    ],
    result: "+2K Instagram followers in 3 months.",
  },
  {
    slug: "love-water",
    title: "Bin The Wipe",
    client: "Love Water UK",
    year: "Strategy",
    discipline: "Communication Strategy",
    tagline: "Make binning the new normal.",
    summary:
      "A behaviour-change campaign that hitched wet-wipe disposal to British social norms.",
    cover:
      "https://images.unsplash.com/photo-1523362628745-0c100150b504?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    size: "small",
    brief:
      "Reduce wet-wipe pollution by getting people to bin, not flush, wipes, and grow Love Water’s reach.",
    insight:
      "Brits don’t debate social norms; they just follow them. Make binning a norm, and the behaviour follows without a lecture.",
    idea:
      "#BinningIsNormal, equate binning the wipe to the everyday norms people already never question.",
    approach: [
      "Built a norm-anchoring strategy with a partner.",
      "Delivered 5 Instagram & Twitter posts around #BinTheWipe.",
    ],
    lines: [
      "If you follow the queue, you can BIN THE WIPE.",
      "If you cover your mouth while sneezing, you can BIN THE WIPE.",
      "93% of blockages are caused by flushing wet wipes.",
    ],
    gallery: [
      "/love-water/bw-01.jpg", "/love-water/bw-02.jpg", "/love-water/bw-03.jpg",
      "/love-water/bw-04.jpg", "/love-water/bw-05.jpg",
    ],
    result: "A shareable behaviour-change framework built on social proof.",
  },
];

const WORK_ORDER = [
  "uncologne",
  "ownly",
  "partysmart",
  "locobear",
  "saarthi",
  "billabong",
  "bpl",
  "fampay",
  "godrej",
  "yourdost",
  "love-water",
];

export const WORK = [...WORK_SOURCE].sort(
  (a, b) => WORK_ORDER.indexOf(a.slug) - WORK_ORDER.indexOf(b.slug)
);

export const getWork = (slug) => WORK.find((w) => w.slug === slug);
